import { createFileRoute } from '@tanstack/react-router';
import { QueryTab } from '@/pages/workspaces/journeys/integrations/sql-sync/import/tabs/query-tab';

/** The Query tab: edit and re-run the import's query. */
export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query',
)({
  component: QueryTab,
});
